import { FC, useEffect } from "react";
import { ChangeSearchValue } from "toolkit/documents/documents.slice";
import { useAppDispatch } from "toolkit/hooks";
import { Carousel } from "./Carousel/Carousel";
import { Tables } from "./Tables/Tables";

export const Categorization: FC = () => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		// if (condition === "archive") dispatch(changeCurrentTab("ENUM"));
		// else dispatch(changeCurrentTab("ORDER"));

		return () => {
			dispatch(ChangeSearchValue(""));
		};
		//eslint-disable-next-line
	}, []);

	return (
		<>
			<Carousel />
			<Tables />
		</>
	);
};
